<main role="main" class="anp-chiffre not-home-page">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <app-breadcrumb></app-breadcrumb>
              
          <h2>{{'ANPEnChiffre.Titre' | translate}}</h2>
          <h3>{{Bloc1Title}}</h3>
          <p>{{Bloc1Description}}</p>
        </div>
        
          <div *ngIf= "pieloaded" class="col-md-4 bloc-shadow" id="chart-trafic-port">
            <highcharts-chart 
                [Highcharts]="highCharts"
                [options]="chartOptions"          
                style="padding:10px;width: 100%; height: 400px; display: block;"
            ></highcharts-chart>
          </div>
        
          <div *ngIf= "pieloaded2" class="col-md-4 bloc-shadow" id="chart-trafic-mode">
            <highcharts-chart 
                [Highcharts]="highCharts"
                [options]="chartOptions2"          
                style="padding:10px;width: 100%; height: 400px; display: block;"
            ></highcharts-chart>
          </div>
       
          <div *ngIf= "pieloaded3" class="col-md-4 bloc-shadow" id="chart-structurtrafic">
            <highcharts-chart 
                [Highcharts]="highCharts"
                [options]="chartOptions3"          
                style="padding:10px;width: 100%; height: 400px; display: block;"
            ></highcharts-chart>
          </div>
        <div class="col-md-12">
          <div class="bloc-shadow">
            <p>{{Table1Name}}</p>
            <div class="table-responsive">
              <table class="table table-bordered">
              <thead class="thead-light">
                <tr>
                  <th *ngFor="let data of Table1Data" class="text-center" scope="col">{{data.titre}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center" *ngFor="let data of Table1Data">
                    <span class="bigspan LeftToRight">{{data.valeur}}</span><br /> 
                    <span class="mediumspan">{{data.unit}}</span>                    
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
            <p class="description" *ngFor="let data of Table1Description">
               {{data}}
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h3>{{Bloc2Title}}</h3>
        </div>
        <div *ngIf= "pieloaded4" class="col-md-6 bloc-shadow box" id="chart-structureffectifs">
            <highcharts-chart 
                [Highcharts]="highCharts"
                [options]="chartOptions4"          
                style="padding:10px;width: 100%; height: 350px; display: block;"
            ></highcharts-chart>
        </div>
        <div class="col-md-6">
          <div class="bloc-shadow">
            <!-- <p>{{Table2Name}}</p> -->
              <table class="table table-bordered">
                <thead class="thead-light">
                  <tr *ngIf="Table2Data.length >0">
                    <th scope="col" class="text-center">{{Table2Data[0].Titre}}</th>
                    <th scope="col" class="text-center">{{Table2Data[0].Valeur}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-info" *ngFor="let data of Table2Data;let index = index">
                    <td *ngIf="index > 0" scope="row"><div [innerHTML]="data.Titre"></div></td>
                    <td class="text-center LeftToRight" *ngIf="index > 0">{{data.Valeur}}</td>
                  </tr>                
                </tbody>
                <thead class="thead-light">
                  <tr class="table-info" *ngFor="let data of Table2Resultats">
                    <th scope="row">{{data.Titre}}</th>
                    <th class="text-center LeftToRight" scope="row">{{data.Valeur}}</th>
                  </tr>
                </thead>
              </table>

          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h3>{{Bloc3Title}}</h3>
        </div>
        <div class="col-md-6">
          <div *ngIf= "barloaded1" class="bloc-shadow" id="chart-evolutionCA">
            <highcharts-chart 
                [Highcharts]="highCharts"
                [options]="chartOptions5"          
                style="padding:10px;width: 100%; height: 400px; display: block;"
            ></highcharts-chart>
          </div>
        </div>
        <div *ngIf= "pieloaded5" class="col-md-6 bloc-shadow" id="chart-repartitionCA">
            <highcharts-chart 
                [Highcharts]="highCharts"
                [options]="chartOptions6"          
                style="padding:10px;width: 100%; height: 400px; display: block;"
            ></highcharts-chart> 
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h3>{{Bloc4Title}}</h3>
          <p class="sub-title">{{Bloc4Description}}</p>
        </div>
        <div class="col-md-6">
          <div class="bloc-shadow">
            <p>{{Table3Name}}</p>
            <table class="table table-bordered">
              <thead class="thead-light">
                <tr *ngIf="Table3Data.length >0">
                  <th scope="col" class="text-center">{{Table3Data[0].Titre}}</th>
                  <th scope="col" class="text-center">{{Table3Data[0].Valeur}}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-info" *ngFor="let data of Table3Data;let index = index">
                  <td *ngIf="index > 0" scope="row"><div [innerHTML]="data.Titre"></div></td>
                  <td class="text-center LeftToRight" *ngIf="index > 0">{{data.Valeur}}</td>
                </tr>                
              </tbody>
              <tfoot>
                <tr class="table-info" *ngFor="let data of Table3Resultats">
                  <th scope="row">{{data.Titre}}</th>
                  <th class="text-center LeftToRight" scope="row">{{data.Valeur}}</th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="col-md-6">
          <div class="bloc-shadow">
            <p>{{Table4Name}}</p>
            <table class="table table-bordered">
              <thead class="thead-light">
                <tr *ngIf="Table4Data.length >0">
                  <th scope="col">{{Table4Data[0].Titre}}</th>
                  <th scope="col">{{Table4Data[0].Valeur}}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-info" *ngFor="let data of Table4Data;let index = index">
                  <td *ngIf="index > 0" scope="row"><div [innerHTML]="data.Titre"></div></td>
                  <td class="text-center LeftToRight" *ngIf="index > 0">{{data.Valeur}}</td>
                </tr> 
              </tbody>
            </table>
          </div>
          <div class="bloc-shadow">
            <p>{{Table5Name}}</p>
            <table class="table table-bordered">
              <thead class="thead-light">
                <tr *ngIf="Table5Data.length >0">
                  <th scope="col">{{Table5Data[0].Titre}}</th>
                  <th scope="col">{{Table5Data[0].Valeur}}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-info" *ngFor="let data of Table5Data;let index = index">
                  <td *ngIf="index > 0" scope="row"><div [innerHTML]="data.Titre"></div></td>
                  <td class="text-center LeftToRight" *ngIf="index > 0">{{data.Valeur}}</td>
                </tr> 
              </tbody>
            </table>
          </div>
          <div class="bloc-shadow">
            <p>{{Table6Name}}</p>
            <table class="table table-bordered">
              <thead class="thead-light">
                <tr *ngIf="Table6Data.length >0">
                  <th scope="col">{{Table6Data[0].Titre}}</th>
                  <th scope="col">{{Table6Data[0].Valeur}}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-info" *ngFor="let data of Table6Data;let index = index">
                  <td *ngIf="index > 0" scope="row"><div [innerHTML]="data.Titre"></div></td>
                  <td class="text-center LeftToRight"  *ngIf="index > 0">{{data.Valeur}}</td>
                </tr> 
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </main>